export default "__VITE_ASSET__C_YPCpx3__"